import React, { useEffect, useState } from "react";
import Testi1Image from "../../assets/images/testimonials/testi1.png";
import Testi2Image from "../../assets/images/testimonials/testi2.png";
import Testi3Image from "../../assets/images/testimonials/testi3.png";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const Testimonials = () => {
  const options = {
    loop: true,
    margin: 0,
    nav: true,
    responsiveClass: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplaySpeed: 1000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
        nav: false,
      },
      480: {
        items: 1,
        nav: false,
      },
      667: {
        items: 1,
        nav: true,
      },
      1000: {
        items: 1,
        nav: true,
      },
    },
  };

  return (
    <>
      <section
        className="w3l-testimonials testimonials-wrapper"
        id="testimonials"
      >
        <div className="max-container">
          <div className="padd-90">
            <div className=" text-center mb40">
              <h2 className="roboto-bold mb10 heading29px">
                What Our Clients Say!
              </h2>
              <p className="heading16px roboto-regular ">
                Valuable & Commendable Feedback from Our Customers
              </p>
            </div>

            <OwlCarousel
              id="customer-testimonoals"
              style={{ maxWidth: 1000 }}
              className="owl-testimonial owl-carousel owl-theme mx-auto"
              {...options}
            >
              <div className="item">
                <div className="testimonial-box">
                  <div className="slider-info">
                    <div className="img-circle">
                      <img
                        src={Testi1Image}
                        className="img-fluid rounded"
                        alt="client"
                      />
                    </div>
                    <div className="message-info">
                      <span className="fa fa-quote-left mr-2"></span>
                      <p className="heading16px roboto-regular">
                        “BeyondLeadz's database is comprehensive and well-maintained, providing accurate contact information and detailed segmentation that allows me to tailor my outreach to specific audiences. The data is also verified and updated regularly, giving me confidence that I’m reaching the right people at the right time.”
                      </p>
                    </div>
                  </div>

                  <hr />

                  <div className="name-flex">
                    <div>
                      <p className="heading18px roboto-bold mb0">
                        Operations Manager
                      </p>
                      <p className="heading15px roboto-regular">
                        Leading Hotel Chain in Delhi
                      </p>
                    </div>
                    <div className="stars-part">
                      <p>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="testimonial-box">
                  <div className="slider-info">
                    <div className="img-circle">
                      <img
                        src={Testi2Image}
                        className="img-fluid rounded"
                        alt="client"
                      />
                    </div>
                    <div className="message-info">
                      <span className="fa fa-quote-left mr-2"></span>
                      <p className="heading16px roboto-regular">
                        “I highly recommend BeyondLeadz to anyone looking for high-quality data to enhance their marketing efforts. They are a reliable and trustworthy partner, and I look forward to continuing our collaboration in the future.”
                      </p>
                    </div>
                  </div>

                  <hr />

                  <div className="name-flex">
                    <div>
                      <p className="heading18px roboto-bold mb0">
                        Front Office Manager
                      </p>
                      <p className="heading15px roboto-regular">
                        5-Star Hotel in Jaipur
                      </p>
                    </div>
                    <div className="stars-part">
                      <p>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="item">
                <div className="testimonial-box">
                  <div className="slider-info">
                    <div className="img-circle">
                      <img
                        src={Testi3Image}
                        className="img-fluid rounded"
                        alt="client"
                      />
                    </div>
                    <div className="message-info">
                      <span className="fa fa-quote-left mr-2"></span>
                      <p className="heading16px roboto-regular">
                        “I have been using BeyondLeadz for some time now, and I must say that their data is top-notch. As a marketer, I rely heavily on accurate and up-to-date data to reach my target audience, and BeyondLeadz has consistently delivered.”
                      </p>
                    </div>
                  </div>

                  <hr />

                  <div className="name-flex">
                    <div>
                      <p className="heading18px roboto-bold mb0">
                        Marketing Manager
                      </p>
                      <p className="heading15px roboto-regular">
                        Leading Beachfront Resort in Thailand
                      </p>
                    </div>
                    <div className="stars-part">
                      <p>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                        <i class="star"></i>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="item">
                                <div className="slider-info">
                                    <div className="img-circle">
                                        <img src={Testi1Image} className="img-fluid rounded" alt="client" />
                                    </div>
                                    <div className="message-info">
                                        <span className="fa fa-quote-left mr-2"></span>
                                        <p className="heading16px roboto-regular">“BeyonLeadz's database is comprehensive and well-maintained, with accurate contact information and detailed segmentation that allows me to tailor my outreach to specific audiences. The data is also verified and updated regularly, which gives me confidence that I'm reaching the right people at the right time”.</p>
                                        <p className="name heading20px roboto-bold mb0 mt20">- Happy Customer</p>
                                        <p className="desp heading15px roboto-regular">Company ,City</p>
                                    </div>
                                </div>
                            </div>

                            <div className="item">
                                <div className="slider-info">
                                    <div className="img-circle">
                                        <img src={Testi2Image} className="img-fluid rounded" alt="client" />                        </div>
                                    <div className="message-info">
                                        <span className="fa fa-quote-left mr-2"></span>
                                        <p className="heading16px roboto-regular">"I highly recommend BeyondLeadz to anyone looking for high-quality data that can help drive their marketing efforts. They are a reliable and trustworthy partner, and I look forward to continuing to work with them in the future."</p>
                                        <p className="name heading20px roboto-bold mb0 mt20">- Happy Customer</p>
                                        <p className="desp heading15px roboto-regular">Company, City</p>
                                    </div>
                                </div>
                            </div>

                            <div className="item">
                                <div className="slider-info">
                                    <div className="img-circle">
                                        <img src={Testi3Image} className="img-fluid rounded" alt="client" />                        </div>
                                    <div className="message-info">
                                        <span className="fa fa-quote-left mr-2"></span>
                                        <p className="heading16px roboto-regular">"I have been using  BeyondLeadz for sometime now, and I have to say that their data is top-notch. As a marketer, I rely heavily on accurate and up-to-date data to reach my target audience, and BeyondLeadz has consistently delivered."</p>
                                        <p className="name heading20px roboto-bold mb0 mt20">- Happy Customer</p>
                                        <p className="desp heading15px roboto-regular">Company, City</p>
                                    </div>
                                </div>
                            </div> */}
            </OwlCarousel>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;
